import React from 'react';

const HykLogo = ({ width = 120, height = 120, className = "", color = "#FF3232" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 71 92" 
      fill="none"
      className={className}
    >
      <path 
        d="M70.05 79.61C65.0607 75.8607 60.977 71.0389 58.1004 65.5003C55.2238 59.9617 53.6277 53.8479 53.43 47.61C59.0355 48.3074 64.588 49.3798 70.05 50.82V36.82C65.21 35.87 60.15 35.11 54.9 34.56C57.2796 25.5958 62.6183 17.6987 70.05 12.15V0C56.31 4.14 45.45 17.1 41.82 33.64C39.64 33.57 37.43 33.53 35.21 33.53C32.99 33.53 30.55 33.53 28.21 33.65C24.58 17.11 13.73 4.14999 0 0.00999451V12.07C7.48512 17.6195 12.8652 25.5451 15.26 34.55C9.96998 35.11 4.87 35.88 0 36.85V50.85C5.49703 49.3908 11.0864 48.305 16.73 47.6C16.5364 53.8578 14.9365 59.9917 12.049 65.5469C9.16144 71.1021 5.06042 75.9359 0.0499878 79.69V91.56C16.81 86.5 29.28 68.29 29.55 46.51C31.35 46.44 33.18 46.41 35.02 46.41C36.86 46.41 38.71 46.41 40.52 46.51C40.79 68.3 53.27 86.51 70.05 91.57V79.61Z" 
        fill={color}
      />
    </svg>
  );
};

export default HykLogo; 